import { render, staticRenderFns } from "./MaterialIconPicker.vue?vue&type=template&id=9aaa1814&scoped=true"
import script from "./MaterialIconPicker.vue?vue&type=script&lang=js"
export * from "./MaterialIconPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialIconPicker.vue?vue&type=style&index=0&id=9aaa1814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaa1814",
  null
  
)

export default component.exports